<template>
	<div :class="classObject" @click="toggle()">
		<div v-if="raw" class="content" v-html="text"></div>
		<div v-else class="content">{{ text }}</div>
	</div>
</template>

<script>
export default {
	name: 'MTooltip',
	data() {
		return {
			act: false,
			classObject: {
				mtooltip: true,
				act: this.act
			}
		}
	},
	props: {
		text: {
			type: String,
			default: ''
		},
		raw: {
			type: Boolean,
			default: false
		}
	},
	methods: {
		toggle() {
			this.$set(this, 'act', !this.act);
		}
	}
}
</script>

<style scoped></style>
